import React, { FC, PropsWithChildren } from "react";

import * as Styled from "./styles";

const LoginWrapper: FC<PropsWithChildren> = ({ children }) => (
  <Styled.LoginWrapper>{children}</Styled.LoginWrapper>
);

export default LoginWrapper;
